import type { LocalizationDictionary } from "./LocalizationTypes";
import type { JsonAssetSource } from "../assets/JsonAssetSource";

/**
 * A served dictionary by its bundle-relative path. Anything that is not an object rejects — a source that resolves a
 * missing file as `undefined` (Pixi's `Assets.load` on an alias no bundle lists) included — so the boot's fallback to
 * English catches it instead of reading keys off nothing (the staging "en-US" boot failure of 2026-10-04).
 */
export async function loadLocalizationDictionaryFromBundle(
  bundle: JsonAssetSource,
  path: string,
): Promise<LocalizationDictionary> {
  const json = await bundle.loadJson(path);
  if (typeof json !== "object" || json === null || Array.isArray(json)) {
    throw new Error(`${path}: not a dictionary (${json === undefined ? "the bundle has no such file" : typeof json})`);
  }
  return json as LocalizationDictionary;
}
